export const GET_SURVEYS = 'surveys/GET_SURVEYS';
